import { render, staticRenderFns } from "./SidebarFlyout.vue?vue&type=template&id=3e27fed4&scoped=true"
import script from "./SidebarFlyout.vue?vue&type=script&lang=js"
export * from "./SidebarFlyout.vue?vue&type=script&lang=js"
import style0 from "./SidebarFlyout.vue?vue&type=style&index=0&id=3e27fed4&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3e27fed4",
  null
  
)

export default component.exports